module.exports = __webpack_public_path__ + "img/airplane.6fd516cd.svg";